





















import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class ZoomValue extends Vue {
    @Prop() private userConfigColor! : string;
}
